<template>
  <div style="height: 100%">
    <cTable
      ref="table"
      :fields="fields"
      :modals="modals"
      :header="header"
      :methods="methods"
    >
    </cTable>
  </div>
</template>

<script>
import {
  getClaimList,
  addClaim,
  editClaim,
  cancelClaim,
  deleteClaim,
  uploadFile,
  deleteFile,
  getClaimConfig,
  getClaimDuty,
  financeOperation,
  getOrderType,
  getDuty,
	financeLog,
	DutyClaim,
} from "@/api/claim_management/responsible_claim";
import { getCurrency } from "@/api/finance/currency";
import { getSelectType, getKeysType } from "@/api/public";
import { getAllClient } from "@/api/user/client";
import cTable from "@/base/common/index";
import { getUser } from "@/api/user/internal";
import { mapState } from "vuex";
import copyClick from "@/utils/copyClick";
export default {
  name: "responsible_claim",
  components: {
    cTable,
  },

  async mounted() {
    this.selData = (await getClaimConfig()).data.payload;
    let currency = (await getCurrency({ pageSize: 100 })).data.payload.rows;
    this.header.searchs.forEach(async (item) => {
      if (item.key === "duty_type") item.options = this.selData.duty_type;
      if (item.key === "duty_cause") item.options = this.selData.duty_cause;
      if (item.key === "create_name") item.options = this.selData.create_name;
      if (item.key === "order_type")
        item.options = this.selData.order_type_list;
    });
    this.modals["claim"]["fields"].forEach(async (item) => {
      if (item.key === "duty_type") item.options = this.selData.duty_type;
      if (item.key === "freight_currency") {
        item.options = currency;
      }
      if (item.key === "duty_currency") {
        item.options = currency;
      }
    });
    this.modals["finances"]["fields"].forEach(async (item) => {
      if (item.key === "pay_currency") {
        item.options = currency;
      }
    });
  },
  methods: {
    // 获取颜色
    getColor(status) {
      let color = "";
      switch (status) {
        case 1:
          color = "#ff9900";
          break;
        case 3:
          color = "#ff9900";
          break;
        case 2:
          color = "#ed4014";
          break;
        case 99:
          color = "#19be6b";
          break;
        default:
          color = "#606266";
          break;
      }
      return color;
    },
  },
  data() {
    let that = this;
    return {
      selData: {},
      title: "",
      required: false,
      tabList: [],
      tabName: "",
      methods: {
        list: getClaimList,
        addClaim,
        editClaim,
        cancelClaim,
        deleteClaim,
        uploadFile,
        deleteFile,
        getClaimConfig,
        getClaimDuty,
        getCurrency,
        financeOperation,
        getOrderType,
				financeLog,
      },
      modals: {
				operationLog:{
          config: {
            modalBind: {
              width: 830,
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("actual_receipt") + this.$t("currency_t"),
                key: "pay_currency",
                tooltip: true,
                minWidth: 120,
              },
              {
                name: () => this.$t("bill_proceeds_issuing_confirm"),
                key: "pay_amount",
                tooltip: true,
                minWidth: 120,
              },
							{
							  name: () => this.$t("finances") + this.$t("Remarks"),
							  key: "finance_remarks",
							  tooltip: true,
							  minWidth: 120,
							},
							{
							  name: () => this.$t("cod_ncnd_9_time"),
							  key: "finance_time",
							  tooltip: true,
							  minWidth: 120,
							},
							{
							  name: () => this.$t("operate"),
							  key: "finance_user",
							  tooltip: true,
							  minWidth: 120,
							},
							{
							  name: () => this.$t("operation")+this.$t("time"),
							  key: "create_time",
							  tooltip: true,
							  minWidth: 120,
							},
            ],
          },
        },
        extend: {
          config: {
            listFn: "list",
            modalBind: {
              width: 600,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
          },
          footer: {
            show: false,
          },
          fields: [],
          table: {
            config: {
              height: 600,
            },
            fields: [
              {
                name: () => this.$t("Evidence_file") + this.$t("alipay_name"),
                key: "name",
                tooltip: true,
                minWidth: 100,
              },
              {
                type: "btns",
                width: 150,
                name: () => this.$t("operation"),
                fixed: "right",
                list: [
                  {
                    name: () => this.$t("show"),
                    type: "show",
                    fnName: "showFun",
                    bind: {
                      type: "primary",
                    },
                  },
                ],
                methods: {
                  showFun({ row }) {
                    if (row.is_doc) {
                      window.open(this.$prviewUrl + this.$globalUrl + row.src);
                    } else {
                      window.open(this.$globalUrl + row.src);
                    }
                  },
                },
              },
            ],
          },
        },
        claim: {
          methods: {
            ok({ close, row, fields }) {
              row["extend"] = row["files"];
              this.$page
                .handleRequestMethods(
                  row.id ? "editClaim" : "addClaim",
                  row,
                  true,
                  true
                )
                .then(() => {
                  this.$page.getList();
                  close();
                });
            },
            cancel() {
              this.fields.map((field) => {
                if (field.key === "files") {
                  field.files = [];
                  field.extend = [];
                }
              });
            },
          },
          grid: [
            { airway_number: 24 },
            { order_type: 24 },
            { duty_type: 24 },
            { relation_number: 24 },
            { duty: 24 },
            { show_weight: 24 },
            { other_duty: 24 },
            { duty_cause: 24 },
            { other_cause: 24 },
            { freight_amount: 12, freight_currency: 12 },
            { duty_amount: 12, duty_currency: 12 },
            { quantity: 8, weight: 8, volume: 8 },
            { memorandum: 24 },
            { remarks: 24 },
            { files: 24 },
          ],
          config: {
            modalBind: {
              width: "60%",
              styles: {
                top: "20px",
              },
            },
            modalContentBind: {
              style: "height:80vh;overflow-x:hidden;overflow-y:auto;",
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
              airway_number: [{ required: true }],
              duty_type: [
                {
                  required: true,
                  trigger: "change",
                  type: "number",
                },
              ],
              duty: [
                {
                  required: true,
                  trigger: "change",
                  type: "number",
                },
              ],
              other_duty: [{ required: true }],
              duty_cause: [
                {
                  required: true,
                  trigger: "change",
                  type: "number",
                },
              ],
              other_cause: [{ required: true }],
              // quantity: [{ required: true }],
              // weight: [{ required: true }],
              // volume: [{ required: true }]
              // files: [{ required: true }]
            },
          },
          fields: [
            {
              name: () => this.$t("claim") + this.$t("Odd_Numbers"),
              key: "airway_number",
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") + this.$t("claim") + this.$t("Odd_Numbers")
                );
              },
              bind: {
                type: "textarea",
                autosize: {
                  minRows: 2,
                  maxRows: 5,
                },
              },
              disabled({ row }) {
                return !!row.id;
              },
              methods: {
                async "on-blur"({ value, fields, formData, field }) {
                  if (value && formData["duty_type"] && field.isChange) {
                    let data = (
                      await getClaimDuty({
                        duty_type: formData["duty_type"],
                        airway_number: value,
                      })
                    ).data.payload;
                    formData["show_weight"] = data.show_weight;
                    formData["relation_number"] = data.relation_number;
                    fields.forEach((el) => {
                      if (el.key == "duty" || el.key == "duty_cause") {
                        formData[el.key] = undefined;
                        el.options = data[el.key];
                        field.isChange = false;
                        this.$forceUpdate();
                      }
                    });
                  }
                  if (value) {
                    let data = (
                      await getOrderType({
                        airway_number: value,
                      })
                    ).data.payload;
                    formData["order_type"] = data;
                  }
                },
                "on-change"({ field }) {
                  field["isChange"] = true;
                },
              },
            },
            {
              key: "order_type",
              name: () => this.$t("order_type_t"),
              component: "Input",
              show: ({ row }) => !!row.order_type,
              disabled: true,
            },
            {
              key: "duty_type",
              name: () => this.$t("Responsibility_party") + this.$t("type"),
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("Responsibility_party");
              },
              options: [],
              methods: {
                async "on-change"({ value, fields, formData }) {
                  if (value && formData["airway_number"]) {
                    let data = (
                      await getClaimDuty({
                        duty_type: value,
                        airway_number: formData.airway_number,
                      })
                    ).data.payload;
                    formData["show_weight"] = data.show_weight;
                    formData["relation_number"] = data.relation_number;
                    fields.forEach(async (el) => {
                      if (el.key == "duty" || el.key == "duty_cause") {
                        formData[el.key] = undefined;
                        el.options = data[el.key];
                        this.$forceUpdate();
                      }
                    });
                  }
                },
              },
            },
            {
              key: "relation_number",
              name: () => this.$t("relation") + this.$t("Odd_Numbers"),
              component: "Input",
              show: ({ row }) => !!row.relation_number,
              disabled: true,
            },
            {
              key: "duty",
              name: () => this.$t("Responsibility_party"),
              component: "Select",
              options: [],
              show({ row }) {
                return (
                  row.airway_number && row.duty_type && row.duty_type != 99
                );
              },
              placeholder() {
                return this.$t("select") + this.$t("Responsibility_party");
              },
            },
            {
              key: "show_weight",
              name: () => this.$t("whether") + this.$t("doubleList"),
              component: "Input",
              show({ row }) {
                return false;
              },
            },
            {
              key: "other_duty",
              name: () => this.$t("orther") + this.$t("Responsibility_party"),
              component: "Input",
              show({ row }) {
                return row.duty_type === 99;
              },
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("orther") +
                  this.$t("Responsibility_party")
                );
              },
            },
            {
              key: "duty_cause",
              name: () => this.$t("Responsibility_party") + this.$t("reason"),
              component: "Select",
              options: [],
              show({ row }) {
                return row.airway_number && row.duty_type;
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("Responsibility_party") +
                  this.$t("reason")
                );
              },
              // show({ row }) {
              //   return !row.is_show;
              // },
            },
            {
              key: "other_cause",
              name: () =>
                this.$t("orther") +
                this.$t("Responsibility_party") +
                this.$t("reason"),
              component: "Input",
              bind: {
                type: "textarea",
                autosize: { minRows: 1 },
              },
              show({ row }) {
                return row.duty_cause === 99;
              },
              placeholder() {
                return (
                  this.$t("orther") +
                  this.$t("Responsibility_party") +
                  this.$t("reason")
                );
              },
            },
            {
              key: "freight_amount",
              name: () => this.$t("cost_fee") + "（" + this.$t("sys") + "）",
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%",
              },
              placeholder() {
                return this.$t("enter") + this.$t("cost_fee");
              },
              default: 0,
            },
            {
              key: "freight_currency",
              name: () =>
                this.$t("finalCost") +
                this.$t("currency_t") +
                "（" +
                this.$t("sys") +
                "）",
              component: "Select",
              options: [],
              config: {
                label: "code",
                value: "code",
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("finalCost") +
                  this.$t("currency_t")
                );
              },
            },
            {
              key: "duty_amount",
              name: () =>
                this.$t("Responsibility_party") +
                this.$t("claim") +
                this.$t("reChAmount"),
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%",
              },
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("Responsibility_party") +
                  this.$t("claim") +
                  this.$t("reChAmount")
                );
              },
              default: 0,
            },
            {
              key: "duty_currency",
              name: () =>
                this.$t("Responsibility_party") +
                this.$t("claim") +
                this.$t("currency_t"),
              component: "Select",
              options: [],
              config: {
                label: "code",
                value: "code",
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("finalCost") +
                  this.$t("currency_t")
                );
              },
            },

            {
              name: () => this.$t("invoicePCS"),
              key: "quantity",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("invoicePCS");
              },
              default: 0,
              show({ row }) {
                return (
                  row.duty_type &&
                  row.airway_number &&
                  (row.duty_type == 2 || row.show_weight == 1)
                );
              },
              bind: {
                type: "number",
                style: "width:100%",
              },
            },
            {
              name: () => this.$t("invoiceWeight"),
              key: "weight",
              default: 0,
              component: "Input",
              show({ row }) {
                return (
                  row.duty_type &&
                  row.airway_number &&
                  (row.duty_type == 2 || row.show_weight == 1)
                );
              },
              placeholder() {
                return this.$t("enter") + this.$t("invoiceWeight");
              },
              bind: {
                type: "number",
                style: "width:100%",
              },
            },
            {
              name: () => this.$t("square"),
              key: "volume",
              component: "Input",
              show({ row }) {
                return (
                  row.duty_type &&
                  row.airway_number &&
                  (row.duty_type == 2 || row.show_weight == 1)
                );
              },
              placeholder() {
                return this.$t("enter") + this.$t("square");
              },
              default: 0,
              bind: {
                type: "number",
                style: "width:100%",
              },
            },
            {
              name: this.$t("indexes") + this.$t("order_desc"),
              key: "memorandum",
              component: "Input",
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("email_subject") +
                  this.$t("related") +
                  this.$t("content")
                );
              },
              bind: {
                type: "textarea",
              },
            },
            {
              name: this.$t("order_desc"),
              key: "remarks",
              component: "Input",
              placeholder() {
                return this.$t("enter") + this.$t("order_desc");
              },
              bind: {
                type: "textarea",
              },
            },
            {
              name: () => this.$t("Evidence_file"),
              key: "files",
              component: "Upload",
              bind: {
                fileName: "files",
                type: "drag",
                // accept: ".xlsx,.xls",
                multiple: true,
                content: this.$t("uploadText") + this.$t("uploadTe"),
              },
              methods: {
                beforeUpload({ file, row }) {
                  row["file"] = file;
                  return false;
                },
              },
              methods: {
                beforeUpload: ({ file, row }) => {
                  let formData = new FormData();
                  formData.append("file", file); // 文件对象
                  uploadFile(formData).then((res) => {
                    if (res.data.status) {
                      if (row["files"]) {
                        row["files"].push({
                          name: file.name,
                          url: res.data.payload,
                        });
                      } else {
                        row["files"] = [
                          {
                            name: file.name,
                            url: res.data.payload,
                          },
                        ];
                      }
                    }
                  });
                  return false;
                },
                delUpload: ({ file, index, key, row }) => {
                  if (file.id) {
                    this.$refs["table"]
                      .handleRequestMethods("deleteFile", {
                        id: file.id,
                      })
                      .then((res) => {
                        row["files"].splice(index, 1);
                      });
                  } else {
                    row["files"].splice(index, 1);
                  }
                },
                fileClick({ row }) {
                  window.open(this.$globalUrl + row.src);
                },
              },
            },
          ],
        },
        finances: {
          // type: "add",
          methods: {
            ok({ close, row, fields }) {
              this.$page
                .handleRequestMethods("financeOperation", row, true, true)
                .then(() => {
                  this.$page.getList();
                  close();
                });
            },
            cancel() {
              close();
            },
          },
          grid: [
            { isPay: 24 },
            { pay_amount: 24 },
            { pay_currency: 24 },
            { finance_time: 24 },
						{ finance_remarks: 24 }
          ],
          config: {
            modalBind: {
              width: 600,
            },
            formBind: {
              labelWidth: 130,
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px",
              },
            },
            rules: {
							isPay: [
							  {
							    required: true,
							    trigger: "change",
							  },
							],
              pay_currency: [
                {
                  required: true,
                  trigger: "change",
                },
              ],
              pay_amount: [
                {
                  required: true,
                  type: "number",
                },
              ],
              finance_time: [
                {
                  required: true,
                  trigger: "change",
                  type: "date",
                },
              ],
              // files: [{ required: true }]
            },
          },
          fields: [
						{
						  key: "isPay",
						  name: () => this.$t("whether") + this.$t("cod_ncnd"),
						  component: "Radio",
						  options: [
								{
									label:'是',
									value:'YES'
								},
								{
									label:'否',
									value:'NO'
								}
							],
						},
            {
              key: "pay_currency",
              name: () => this.$t("actual_receipt") + this.$t("currency_t"),
              component: "Select",
              options: [],
              config: {
                label: "code",
                value: "code",
              },
              placeholder() {
                return (
                  this.$t("select") +
                  this.$t("actual_receipt") +
                  this.$t("currency_t")
                );
              },
            },
            {
              key: "pay_amount",
              name: () => this.$t("actual_receipt") + this.$t("reChAmount"),
              component: "InputNumber",
              bind: {
                min: 0,
                style: "width:100%",
              },
              placeholder() {
                return (
                  this.$t("enter") +
                  this.$t("actual_receipt") +
                  this.$t("reChAmount")
                );
              },
              default: 0,
            },
            {
              key: "finance_time",
              name: () => this.$t("cod_ncnd") + this.$t("date"),
              component: "DatePicker",
              bind: {
                type: "datetime",
                style: "width:100%",
              },
              disabledDate: true,
              placeholder() {
                return (
                  this.$t("select") + this.$t("cod_ncnd") + this.$t("date")
                );
              },
            },
						{
						  key: "finance_remarks",
						  name: () => this.$t("Remarks"),
						  component: "Input",
						  placeholder() {
						    return (
						      this.$t("enter") +
						      this.$t("Remarks")
						    );
						  },
							bind: {
							  type: "textarea",
							  rows: 1,
							},
						},
          ],
        },
      },
      header: {
        searchs: [
          {
            key: "create_name",
            placeholder() {
              return this.$t("select") + this.$t("sponsor");
            },
            component: "Select",
            options: [],
          },
          {
            key: "order_type",
            placeholder() {
              return this.$t("select") + this.$t("order_type_t");
            },
            component: "Select",
            options: [],
          },
          {
            key: "duty_type",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("Responsibility_party") +
                this.$t("type")
              );
            },
            component: "Select",
            options: [],
            methods: {
              async "on-change"({ fields, searchForm }) {
                let data = [];
                if (searchForm["duty_type"]) {
                  data = (await getDuty(searchForm["duty_type"])).data.payload;
                }
                fields.forEach(async (el) => {
                  if (el.key == "duty") {
                    searchForm[el.key] = undefined;
                    el.options = data;
                    this.$forceUpdate();
                  }
                });
              },
            },
          },
          {
            key: "duty",
            placeholder() {
              return this.$t("select") + this.$t("Responsibility_party");
            },
            component: "Select",
            options: [],
          },
          {
            key: "duty_cause",
            placeholder() {
              return (
                this.$t("select") +
                this.$t("Responsibility_party") +
                this.$t("reason")
              );
            },
            component: "Select",
            options: [],
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            bind: {
              type: "textarea",
              rows: 1,
            },
            component: "Input",
            default: this.$route.params.id ? this.$route.params.id : "",
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$t("launch") + this.$t("responsible_claim"),
              type: "claim",
              fnName: "claimFun",
              id: 892,
              bind: {
                type: "warning",
                icon: "md-add",
              },
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "exportFun",
              bind: {
                type: "success",
                icon: "md-download",
              },
              disabled(row) {
                return !this.selectAll.length;
              },
            },
          ],
          methods: {
            exportFun({ row, field, searchForm }) {
              this.exportExc();
            },
            claimFun() {
              this.getModal("claim").open({}, function () {
                this.setTitle(this.$t("launch") + this.$t("responsible_claim"));
              });
            },
          },
        },
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          fixed: "left",
          width: 60,
        },
        {
          name: () => this.$t("sponsor"),
          key: "create_name",
          align: "center",
          width: 100,
        },
        {
          name: () => this.$t("launch") + this.$t("time"),
          key: "create_time",
          align: "center",
          width: 150,
        },
        {
          name: () =>
            this.$t("Responsibility_party") +
            this.$t("claim") +
            this.$t("Odd_Numbers"),
          key: "airway_number",
          align: "center",
          minWidth: 120,
        },
        {
          name: () => this.$t("b2bClient") + this.$t("claim") + this.$t('information'),
          key: "relation_claim",
          align: "center",
          minWidth: 130,
        },
				{
					name: () => this.$t("finances") + this.$t("Remarks"),
					key: "finance_remarks",
					align: "center",
					minWidth: 130,
				},
				{
					name: () => this.$t("relation") + this.$t("Odd_Numbers"),
					key: "relation_number",
					align: "center",
					minWidth: 130,
				},
        {
          name: () => this.$t("order_type_t"),
          key: "order_type_txt",
          align: "center",
          minWidth: 120,
        },
        {
          name: () => this.$t("Responsibility_party") + this.$t("type"),
          key: "duty_type_txt",
          align: "center",
          width: 100,
        },
        {
          name: () => this.$t("Responsibility_party"),
          key: "duty_txt",
          align: "center",
          width: 100,
        },
        {
          name: () => this.$t("Responsibility_party") + this.$t("reason"),
          key: "duty_cause_txt",
          align: "center",
          width: 150,
        },
        {
          name: () => this.$t("DeclaredValue") + "(USD)",
          key: "values",
          align: "center",
          width: 150,
        },
        {
          name: () => this.$t("cost_fee") + "（" + this.$t("sys") + "）",
          key: "freight_amount",
          align: "center",
          width: 100,
        },
        {
          name: () =>
            this.$t("finalCost") +
            this.$t("currency_t") +
            "（" +
            this.$t("sys") +
            "）",
          key: "freight_currency",
          align: "center",
          width: 100,
        },
        {
          name: () =>
            this.$t("Responsibility_party") +
            this.$t("claim") +
            this.$t("reChAmount"),
          key: "duty_amount",
          align: "center",
          width: 100,
        },
        {
          name: () =>
            this.$t("Responsibility_party") +
            this.$t("claim") +
            this.$t("currency_t"),
          key: "duty_currency",
          align: "center",
          width: 100,
        },
        {
          name: () => this.$t("invoicePCS"),
          key: "quantity",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("invoiceWeight"),
          key: "weight",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("square"),
          key: "volume",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("outboundTime"),
          key: "outbound_time",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("indexes") + this.$t("Remarks"),
          key: "memorandum",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("actual_receipt") + this.$t("reChAmount"),
          key: "pay_amount",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("actual_receipt") + this.$t("currency_t"),
          key: "pay_currency",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("cod_ncnd") + this.$t("date"),
          key: "finance_time",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$t("finances") + this.$t("operate"),
          key: "finance_name",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$t("claim") + this.$t("Odd_Numbers"),
          key: "claim_number",
          align: "center",
          minWidth: 220,
        },
        {
          type: "btns",
          width: 250,
          name: () => this.$t("operation"),
          fixed: "right",
          list: [
            {
              name: () => this.$t("finances") + this.$t("operation"),
              type: "finances",
              fnName: "financesFun",
              bind: {
                type: "warning",
              },
							id: 1109,
            },
						{
						  name: () => this.$t("finances") + this.$t("operationLog"),
						  type: "operationLog",
						  fnName: "operationLog",
						  bind: {
						    type: "warning",
						  },
							id: 1110,
						},
            {
              name: () => this.$t("update") + this.$t("responsible_claim"),
              type: "update",
              fnName: "updateFun",
              bind: {
                type: "success",
              },
              id: 891,
            },
            {
              name: () => this.$t("Evidence_file"),
              type: "extend",
              fnName: "extendFun",
              bind: {
                type: "primary",
              },
            },
            {
              name: () => this.$t("delete"),
              type: "delete",
              fnName: "deleteFun",
              bind: {
                type: "error",
              },
              id: 936,
            },
          ],

          methods: {
						async operationLog({row}){
							let res = await this.handleRequestMethods(
							  "financeLog",
							  row.id
							);
							this.getModal("operationLog").open({}, function () {
							  this.setTitle(this.$t("finances") + this.$t("operationLog"));
								this.list = res.payload
							});
						},
            financesFun({ row }) {
              let data = {
                id: row.id,
                pay_amount: row.pay_amount,
                pay_currency: row.pay_currency,
                finance_time: row["finance_time"]
                  ? row["finance_time"]
                  : new Date(),
              };
              this.getModal("finances").open(data, function () {
                this.setTitle(this.$t("finances") + this.$t("operation"));
              });
            },
            async updateFun({ row }) {
							DutyClaim(row.id)
              let data = {
                ...row,
                files: row.extend,
              };
              data["order_type"] = (
                await getOrderType({
                  airway_number: row.airway_number,
                })
              ).data.payload;
              this.handleRequestMethods("getClaimDuty", {
                duty_type: row.duty_type,
                airway_number: row.airway_number,
              }).then((res) => {
                this.getModal("claim").fields.forEach((item) => {
                  if (item.key == "duty" || item.key == "duty_cause") {
                    item.options = res.payload[item.key];
                  }
                });
                row["show_weight"] = res.payload.show_weight;
              });
              this.getModal("claim").open(data, function () {
                this.setTitle(this.$t("update") + this.$t("responsible_claim"));
              });
            },
            extendFun({ row }) {
              this.getModal("extend").open(null, function () {
                this.title = this.$t("Evidence_file");
                this.list = row.extend;
              });
            },
            async recordFun({ row }) {
              let res = await this.handleRequestMethods(
                "getAuditRecord",
                row.id
              );
              this.getModal("record").open(null, function () {
                this.list = res.payload;
                this.setTitle(this.$t("auditOrder") + this.$t("record"));
              });
            },
            deleteFun({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("deleteClaim", row.id).then(
                    (res) => {
                      this.$Message["success"]({
                        background: true,
                        content: res.msg,
                      });
                      this.getList();
                    }
                  );
                },
              });
            },
          },
        },
      ],
    };
  },
};
</script>
<style type="text/css">
.content {
  height: 100%;
}
/* @page{
    size: 7cm 8cm;
  } */
.city-name {
  height: 34px;
  display: inline-block;
  line-height: 34px;
  margin: 5px;
  padding: 0 5px;
  border-radius: 4px;
  border: 1px solid #e8eaec;
}
.city-div :nth-child(3n + 1).city-name {
  color: #fff;
  background-color: #59c48e;
}
.city-div :nth-child(3n).city-name {
  color: #fff;
  background-color: #403868;
}
.city-div :nth-child(3n-1).city-name {
  color: #fff;
  background-color: #616664;
}
</style>
<style lang="scss" scoped></style>
